import { useState } from 'react'
import { Alert } from "reactstrap";
import { announce } from "../../services/env";
import { useReactiveVar } from "@apollo/client";

const Announcement = () => {
  const message: string = useReactiveVar(announce)

  const [visible, setVisible] = useState(true)

  const onDismiss = () => {
    setVisible(false);
  }

  return message ?  <Alert color="info" isOpen={visible} toggle={onDismiss}>{message}</Alert> : <></>
  
}

export default Announcement